module.exports = __webpack_public_path__ + "img/not.32df6861.svg";